import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import VueSweetalert2 from 'vue-sweetalert2';
import moment from "moment";
import { reloadAxios } from "@/repository/api/Axios";
import AuthApi from "@/repository/api/AuthApi";

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/open-sans-icons.css";
import ArgonDashboard from "./argon-dashboard";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import VueAwesomePaginate from "vue-awesome-paginate";

import VueLazyload from 'vue-lazyload'

// import the necessary css file
import "vue-awesome-paginate/dist/style.css";

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import {
    faArrowRightFromBracket,
    faBars,
    faBriefcase,
    faChevronLeft,
    faDesktop,
    faEllipsis,
    faFileLines,
    faGear,
    faPlus,
    faSignal,
    faUser,
    faUsers,
    faClipboardList,
    faAngleDown,
    faClipboardCheck,
    faArrowsRotate,
    faCheck,
    faXmark,
    faChevronRight,
    faEye,
    faEyeSlash,
    faPen,
    faTrash,
    faIdCardClip,
    faCircleInfo,
    faIdCard,
    faBookOpen,
    faServer,
    faUserGroup,
    faFolderOpen,
} from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(
    faDesktop,
    faUsers,
    faSignal,
    faBars,
    faUser,
    faGear,
    faChevronLeft,
    faFileLines,
    faPlus,
    faBriefcase,
    faArrowRightFromBracket,
    faEllipsis,
    faClipboardList,
    faAngleDown,
    faClipboardCheck,
    faArrowsRotate,
    faCheck,
    faXmark,
    faChevronLeft,
    faChevronRight,
    faEye,
    faEyeSlash,
    faPen,
    faTrash,
    faIdCardClip,
    faCircleInfo,
    faIdCard,
    faBookOpen,
    faServer,
    faUserGroup,
    faFolderOpen,
)
const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(VueSweetalert2);
appInstance.use(VueAwesomePaginate);
appInstance.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
});
appInstance.component('font-awesome-icon', FontAwesomeIcon);
appInstance.component('VueDatePicker', VueDatePicker);
appInstance.mixin({
    data() {
        return {
            sessionUser: {},
            timer: undefined,
        };
    },
    methods: {
        convertToMoment(value, format="DD MMMM YYYY, HH:mm", zone="+0700") {
            let output = moment.utc(value);
            if (output.isValid()) {
                return output.utcOffset(zone).format(format);
            }
            return false;
        },
        async getSessionUser() {
            if (this.$store.state.token == "") {
                this.$store.state.token = localStorage.getItem("token");
            }
            await AuthApi.check_token({ token: this.$store.state.token })
                .then((response) => {
                    this.$store.state.sessionUser = response.data.user;
                    this.$store.state.token = response.data.authorization.token;
                    localStorage.setItem("token", response.data.authorization.token)

                }).catch((error) => {
                    if (error?.response?.status === 401) {
                        if (this.$store.state?.token) {
                            this.logout();
                        }
                        
                        this.$router.push({ name: "Signin" })

                    } else {
                        console.log(error)
                        this.$swal({
                            icon: "error",
                            title: error?.response?.data?.message || 'Shomething wrong, please try again!',
                        });
                    }

                });
        },
        async logout() {
            this.$store.state.loading = true;

            await AuthApi.logout()
                .then(() => {
                    localStorage.removeItem('token');
                    this.$store.state.token = '';
                    reloadAxios()
                    this.$router.push({ name: 'Signin' });
                })
                .catch((err) => {
                    console.log(err)
                    this.$swal({
                        icon: "error",
                        title: err?.response?.data?.message || 'Shomething wrong, please try again!',
                    })
                });
            
            this.$store.state.loading = false;
        },
    },
})
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
